import PolicyCoverages from './components/PolicyCoverages/PolicyCoverages';
import PolicyCommonDetails from './components/PolicyCommonDetails/PolicyCommonDetails';
import PolicyCommonCoverables from './components/PolicyCommonCoverables/PolicyCommonCoverables';
import PolicyCommonDocuments from './components/PolicyCommonDocuments/PolicyCommonDocuments';
import CECLPolicyCommonDocuments from './components/CECLPolicyCommonDocuments/CECLPolicyCommonDocuments';
import PolicyCommonContacts from './components/PolicyCommonContacts/PolicyCommonContacts';

const policyCommonComponentMap = {
    PolicyCoveragesComponent: { component: 'PolicyCoverages' },
    PolicyCommonDetailsComponent: { component: 'PolicyCommonDetails' },
    PolicyCommonCoverablesComponent: { component: 'PolicyCommonCoverables' },
    PolicyCommonDocuments: { component: 'PolicyCommonDocuments' },
    CECLPolicyCommonDocuments: { component: 'CECLPolicyCommonDocuments' },
    PolicyCommonContacts: { component: 'PolicyCommonContacts' }
};

const policyCommonComponents = {
    PolicyCoverages,
    PolicyCommonDetails,
    PolicyCommonCoverables,
    PolicyCommonDocuments,
    CECLPolicyCommonDocuments,
    PolicyCommonContacts
};

export {
    PolicyCoverages,
    PolicyCommonDetails,
    PolicyCommonDocuments,
    CECLPolicyCommonDocuments,
    PolicyCommonContacts,
    policyCommonComponentMap,
    policyCommonComponents
};
